import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import styles from './yixingZhang.module.css';
import yixing from '../../img/yixing.png';
import erxing from '../../img/erxing.png';
import {FILE_URL} from "../../../../util/constants";

class YixingZhang extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, []);

        this.state = {
            reasonList: props.teseZhangList
        };

    }

    componentDidMount() {


    }

    render() {
        return (
            <div className={styles.root}>
                <div className={styles.shuoming}>{this.props.yixingData.shuoming}</div>

                <div className={styles["div-hz"]}>
                    <img className={styles["img-hz"]} src={FILE_URL + this.props.yixingData.img}/>
                </div>
            </div>
        );
    }
}


export default YixingZhang;
